"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaveDataApi = SaveDataApi;
exports.designListApi = designListApi;
exports.getBottomNavigationApi = getBottomNavigationApi;
exports.getDataApi = getDataApi;
exports.goodDesignList = goodDesignList;
exports.groupDataList = groupDataList;
exports.groupDelete = groupDelete;
exports.groupEdit = groupEdit;
exports.groupInfo = groupInfo;
exports.groupList = groupList;
exports.groupSave = groupSave;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function groupDelete(params) {
  var data = {
    id: params.id
  };
  return (0, _request.default)({
    url: 'admin/platform/system/group/delete',
    method: 'GET',
    params: data
  });
}
function groupInfo(params) {
  var data = {
    id: params.id
  };
  return (0, _request.default)({
    url: 'admin/platform/system/group/info',
    method: 'GET',
    params: data
  });
}
function groupList(params) {
  var data = {
    keywords: params.keywords,
    page: params.page,
    limit: params.limit
  };
  return (0, _request.default)({
    url: 'admin/platform/system/group/list',
    method: 'GET',
    params: data
  });
}
function groupDataList(params) {
  var data = {
    gid: params.gid,
    keywords: params.keywords,
    page: params.page,
    limit: params.limit
  };
  return (0, _request.default)({
    url: 'admin/platform/system/group/data/list',
    method: 'GET',
    params: data
  });
}
function groupSave(params) {
  var data = {
    formId: params.formId,
    info: params.info,
    name: params.name
  };
  return (0, _request.default)({
    url: 'admin/platform/system/group/save',
    method: 'POST',
    params: data
  });
}
function groupEdit(params) {
  var data = {
    formId: params.formId,
    info: params.info,
    name: params.name,
    id: params.id
  };
  return (0, _request.default)({
    url: 'admin/platform/system/group/update',
    method: 'POST',
    params: data
  });
}

/**
 * @description 页面设计 获取数据
 */
function designListApi() {
  return _request.default.get("admin/platform/page/layout/index");
}

/**
 * @description 页面设计商品Tab 获取数据
 */
function goodDesignList(params) {
  var data = {
    gid: params.gid
  };
  return (0, _request.default)({
    url: 'admin/platform/system/group/data/list',
    method: 'GET',
    params: data
  });
}

/**
 * @description 页面设计 保存
 */
function SaveDataApi(data, url) {
  return (0, _request.default)({
    url: url,
    method: 'POST',
    data: data
  });
}

/**
 * @description 获取配置
 */
function getDataApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/page/layout/category/config',
    method: 'GET',
    data: data
  });
}

/**
 * @description 页面底部导航
 */
function getBottomNavigationApi() {
  return (0, _request.default)({
    url: 'admin/platform/page/layout/bottom/navigation/get',
    method: 'GET'
  });
}